export default {
  load: function (config) {

    if (!config) {
      return false
    }

    config.canChooseEnv = config.canChooseEnv || false
    config.theme = config.theme || 'dark-theme'
    if (!config.envList || !config.envList.length) {
      throw new Error('envlist is missing or empty in config')
    }
    config.envList.map(env => {
      if (!env.name) throw new Error('missing environment name')
      if (!env.host) throw new Error('missing host for ' + env.name)
      if (!env.port) throw new Error('missing port for ' + env.name)
      env.ssl = env.ssl || false
      env.maxDocumentSize = env.maxDocumentSize || '5M'
      let arr = /^([0-9]+)[ ]*([KMG]?)(bytes)?$/.exec(env.maxDocumentSize)
      if (!arr) {
        throw new Error('invalid maxDocumentSize for ' + env.name + ': ' + env.maxDocumentSize)
      }
      else {
        env.maxFileSize = Number(arr[1])
        if (arr[2] === 'K') env.maxFileSize *= 1024
        if (arr[2] === 'M') env.maxFileSize *= 1024 * 1024
        if (arr[2] === 'G') env.maxFileSize *= 1024 * 1024
        env.maxDocumentSize = arr[1] + ' ' + arr[2] + 'bytes'
      }
    })
    return config
  }
}
